<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap >
      <v-flex sm12>

        <div class="col-md-12" style="float: right;">
          <v-dialog v-model="modalfilter.dialog" persistent max-width="50%">
            <v-btn color="primary" dark slot="activator">Filtrar por Data</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">Escolha a data</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                      label="Data Desejada"
                      type="date"
                      v-model="dayStart"
                      required autofocus></v-text-field>
                    </v-flex>                    
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="updateFilter()">Buscar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>



        <div class="col-md-12" style="float: right;">
          <v-dialog v-model="modalday.dialog" persistent max-width="1500px">
            <v-btn color="primary" dark slot="activator">Novo Agendamento</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">Cadastrando um agendamento</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs6>
                      <v-select
                      label="Selecione o exame"
                      :items="scheduletypes"
                      v-model="shedule.schedule_type_id"
                      autocomplete
                      item-text="name"
                      item-value="id"                           
                      ></v-select>
                    </v-flex>
                    <v-flex lg6>  
                      <v-select
                      label="Selecione o colaborador"
                      :items="employeesall"
                      v-model="shedule.employee_id"
                      autocomplete
                      item-text="employee_name"
                      item-value="employee_id"                           
                      ></v-select>
                    </v-flex>
                    <v-flex lg4>
                      <v-date-picker v-model="shedule.date" :landscape="landscape" locale="pt-br"></v-date-picker>
                    </v-flex>
                    <v-flex lg6 style="margin-left: 100px">           
                      <v-select
                      label="Selecione o Horário"
                      :items="sheduleTime"
                      v-model="shedule.time"                         
                      ></v-select>
                    <!-- </v-flex>                    
                      <v-flex lg4>  -->          
                        <label><input type="checkbox" v-model="audiometria" value="true" /> Audiometria</label>
                        <label><input type="checkbox" v-model="eletrocardiograma" value="true" /> Eletrocardiograma</label>
                        <label><input type="checkbox" v-model="psicosocial" value="true" /> Psicosocial</label>
                        <label><input type="checkbox" v-model="espirometria" value="true" /> Espirometria</label>
                        <label><input type="checkbox" v-model="sangue" value="true" /> Exames de Sangue</label>                      
                        <label><input type="checkbox" v-model="raiox" value="true" /> Raio X</label>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        label="Exames Complementares"
                        v-model="complement"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click.native="modalEmpresasLista.dialog = true">Empresas/Funcionários</v-btn>
                  <v-btn color="primary" flat @click.native="modalEmpresa.dialog = true">Nova Empresa</v-btn>
                  <v-btn color="blue darken-1" flat @click.native="modalday.dialog = false">Fechar</v-btn>
                  <v-btn color="blue darken-1" flat @click="createShedules()">Salvar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-flex>

        <!-- tabela dos alunos treinamentos -->  
        <v-flex lg12>
          <vue-good-table
          :columns="columns"
          :rows="filteredAgendamentos"
          @on-row-click="onCellClick"
          @on-cell-click="onCellClick"
          :pagination-options="{
            enabled: true,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Registros por página',
            ofLabel: 'of',
            allLabel: 'Todos',
          }"
          styleClass="vgt-table bordered vgt-table condensed">
        </vue-good-table>
      </v-flex>

      <v-flex lg12>
        <v-card >
          <v-alert outline color="info" icon="info" :value="true">
            Clique sobre o agendamento para editar
          </v-alert>
        </v-card> 
      </v-flex>

      <!-- editando agendamento -->
      <v-flex>
        <v-dialog v-model="modalagendaedit.dialog" persistent max-width="900px">
          <v-card>
            <v-card-title>
              <span class="headline">Editando um agendamento</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs6>
                    <v-select
                    label="Selecione o treinamento"
                    :items="scheduletypes"
                    v-model="dados_shedules.schedule_type_id"
                    autocomplete
                    item-text="name"
                    item-value="id"                           
                    ></v-select>
                  </v-flex>
                  <v-flex lg6>  
                    <v-select
                    label="Selecione o colaborador"
                    :items="employeesall"
                    v-model="dados_shedules.employee_id"
                    autocomplete
                    item-text="employee_name"
                    item-value="employee_id"                             
                    ></v-select>
                  </v-flex>
                  <v-flex lg8>
                    <v-date-picker v-model="dados_shedules.date" :landscape="landscape" locale="pt-br"></v-date-picker>
                  </v-flex>
                  <v-flex lg4>           
                    <v-select
                    label="Selecione o Horário"
                    :items="sheduleTime"
                    v-model="dados_shedules.time"
                    autocomplete
                    item-text="time"
                    item-value="time"                         
                    ></v-select>
                  </v-flex>
                  <v-flex lg12>           
                    <label><input type="checkbox" v-model="dados_shedules.audiometria" value="true" /> Audiometria</label>
                    <label><input type="checkbox" v-model="dados_shedules.eletrocardiograma" value="true" /> Eletrocardiograma</label>
                    <label><input type="checkbox" v-model="dados_shedules.psicosocial" value="true" /> Psicossocial</label>
                    <label><input type="checkbox" v-model="dados_shedules.espirometria" value="true" /> Espirometria</label>
                    <label><input type="checkbox" v-model="dados_shedules.sangue" value="true" /> Exames de Sangue</label>                      
                    <label><input type="checkbox" v-model="dados_shedules.raiox" value="true" /> Raio X</label>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    label="Exames Complementares"
                    v-model="dados_shedules.complement"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="modalagendaedit.dialog = false">Fechar</v-btn>
              <v-btn color="blue darken-1" flat @click="updateShedules()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex> 

      <v-flex sm12>
        <v-dialog v-model="modalEmpresa.dialog" persistent max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Cadastro de Empresa</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                    label="Nome"
                    v-model="empresa.name"
                    :rules="[rules.required]"
                    required></v-text-field>
                  </v-flex>            
                  <v-flex xs12>
                    <v-text-field
                    label="CNPJ"
                    v-model="empresa.cnpj"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    ></v-text-field>
                  </v-flex>              
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="modalEmpresa.dialog = false">Fechar</v-btn>
            <v-btn color="blue darken-1" flat @click="creatEmpresa()">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>      


    <v-flex sm6>
      <v-dialog v-model="modalEmpresasLista.dialog" persistent max-width="50%">
        <v-card>
          <vue-good-table
          :columns="columnsCompanies"
          :rows="companies"
          @on-row-click="onCellClickComponies"
          @on-cell-click="onCellClickComponies"
          :pagination-options="{
            enabled: true,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Registros por página',
            ofLabel: 'of',
            allLabel: 'Todos',
          }"
          styleClass="vgt-table bordered vgt-table condensed"
          />  
        </vue-good-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="modalEmpresasLista.dialog = false">Fechar</v-btn>
        </v-card-actions>
        <v-flex lg12>
          <v-card >
            <v-alert outline color="warning" icon="warning" :value="true">
              Clique sobre a empresa para cadastrar um novo colaborador
            </v-alert>
          </v-card> 
        </v-flex>
      </v-card>
    </v-dialog>
  </v-flex>

  <v-flex sm12>
    <v-dialog v-model="modalEmployeds.dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Cadastrando funcionáro na empresa: {{ nomeEmpresa }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-flex xs10>
              <v-text-field
              label="Nome"
              v-model="funcionario.name"
              :rules="[rules.required]"  
              ></v-text-field>
            </v-flex>            
            <v-flex xs6>
              <v-text-field
              label="CPF"
              v-mask="['###.###.###-##']"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              label="RG"
              v-model="funcionario.rg"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              label="Cargo"
              v-model="funcionario.office"
              ></v-text-field>
            </v-flex>                                                             
            <v-flex xs3>
              <v-text-field
              label="CTPS"
              v-model="funcionario.ctps"
              ></v-text-field>
            </v-flex>                         
            <v-flex xs3>
              <v-text-field
              label="PIS"
              v-model="funcionario.pis"
              ></v-text-field>
            </v-flex>                               
            <v-flex xs4>
              <input type="radio" id="one" value="M" v-model="funcionario.gender">
              <label for="one">Masculino</label>
              <br>
              <input type="radio" id="two" value="F" v-model="funcionario.gender">
              <label for="two">Femenino</label>
            </v-flex>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="modalEmployeds.dialog = false">Fechar</v-btn>
              <v-btn color="blue darken-1" flat @click="createFuncionario()">Salvar</v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>                                
      </v-card>
    </v-dialog>
  </v-flex>

</v-layout>
</v-container>
</template>

<script>
  import {http, httpLogin} from '../../backend/vue-axios/axios';
  import swal from 'sweetalert';
  import { mapGetters } from 'vuex';
  import * as moment from 'moment';
  export default {
    data () {
      return {
        file: '',
        search: '',
        companies: [],
        schedules: [],
        dados_trainings: [],
        shedule: [],
        scheduletypes: [],
        dados_shedules: [],
        employeesall: [],
        sheduleTime: ['07:00:00', '07:30:00'],
        columns: [
        {
          label: 'Colaborador',
          field: 'employee.name',
          filterOptions: {
            enabled: true,
            placeholder: 'Informe o nome do colaborador', 
            filterDropdownItems: [],
            filterFn: this.columnFilterFn, 
          },
        },      
        {
          label: 'Consulta/Tipo',
          field: 'schedule_type.name',
        },      
        {
          label: 'Empresa',
          field: 'employee.company.name',
          filterOptions: {
            enabled: true,
            placeholder: 'Informe o nome da Empresa', 
            filterDropdownItems: [],
            filterFn: this.columnFilterFn, 
          },
        },
        {
          label: 'Data',
          field: 'date',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'DD/MM/YYYY',
        },
        {
          label: 'Edição',
          field: 'btnedit',
          html: true,
        },      
        {
          label: 'Excluir',
          field: 'btnexcluir',
          html: true,
        },
        ],
        columnsCompanies: [
        {
          label: 'Nome',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'Informe o nome da empresa', 
            filterDropdownItems: [], 
            filterFn: this.columnFilterFn,
          },
          tdClass: 'text-center',
        }                
          ],
          dayStart: '',
          modalday: {
            dialog: false
          },
          audiometria: false,
          eletrocardiograma: false,
          psicosocial: false,
          espirometria: false,
          sangue: false,
          raiox: false,
          complement: null,
          modalagendaedit: {
            dialog: false,
          },      
          modalfilter: {
            dialog: false,
          },        
          modalEmpresa: {
            dialog: false,
          },        
          modalEmpresasLista: {
            dialog: false,
          },        
          modalEmployeds: {
            dialog: false,
          },
          empresa: {
            name: '',
            cnpj: '',
            ativo: '', 
            email:'',
            password_visible: '',
            user_id: '',
            phone: '',
          },
          funcionario: {
            name:'',
            cpf:'',
            office:'',
            gender: '',
            pis: '',
            ctps: '',
            rg: '',
            admission: '',
            born_date: '',
          },
          idEmpresa: '',
          nomeEmpresa: '',
          id_user: '',
          rules: {
            required: (value) => !!value || 'Campo Obrigtório.',
            email: (value) => {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return pattern.test(value) || 'E-mail inválido.';
            } 
          },
        };
      },

      computed: {
        filteredAgendamentos: function() {

          var date = this.dayStart;

          if(date == "") {
            return this.schedules;
          } else {
            return this.schedules.filter(function(agendamento) {
              return agendamento.date == date;
            });
          }
        }
      },

      mounted () {
        this.buscaAgendamentos()
        this.buscaTipoAgendamento()
        this.buscarAllFuncionarios()
        this.buscaEmpresa()
      }, 

      methods: {

        onCellClick(params)
        {
          if(params.column.field == 'btnedit')
          {
            this.clickEdit(params)
          }else if(params.column.field == 'btnexcluir')
          {
            this.clickDelete(params)
          }else{
            this.clickEdit(params)
          } 
        },

        onCellClickComponies(params)
        {
          if(params.row.id)
          {
            this.idEmpresa = params.row.id
            this.nomeEmpresa = params.row.name
            // this.modalEmpresasLista.dialog = false  
            this.modalEmployeds.dialog = true
          // this.divFunc = true
        }
        
      },

      clickEdit(params) {
        if(params.row.id == null || params.row.id == '')
        {
          swal({
            title: "Não",
            text: "foi possível editar o cadastro!",
            icon: "success",
            timer: 1000,
            button: false

          });
        }  
        this.modalagendaedit.dialog = true;

        let data = {
          id: params.row.id,
          time: params.row.time,
          date: params.row.date,
          employee_id: params.row.employee.id,
          schedule_type_id: params.row.schedule_type.id,
          complement: params.row.complement,
          espirometria: params.row.espirometria,
          eletrocardiograma: params.row.eletrocardiograma,
          psicosocial: params.row.psicosocial,
          audiometria: params.row.audiometria,
          raiox: params.row.raiox,
          sangue: params.row.sangue
        }
        this.dados_shedules = data;
      },  

      buscaTipoAgendamento() {

        http.get('scheduletypes')
        .then(response => {
         this.scheduletypes = response.data;
       })
        .catch(error => {
        });
      },

      buscaEmpresa() {
        http.get('companies')
        .then(response => {

         this.companies = response.data;
       })
        .catch(error => {
          console.log();      
        });
      },



      buscaAgendamentos() {
        http.get('schedules')
        .then(response => {
         this.schedules = response.data;

         for (var schedule in this.schedules) {
          this.schedules[schedule].btnedit = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">edit</i></div></button>' ,
          this.schedules[schedule].btnexcluir = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">delete_forever</i></div></button>'
        }
      })
        .catch(error => {
        });
      },

      updateFilter() {
       this.modalfilter.dialog = false
     },

     createShedules() {
      let timeFormated = moment(this.shedule.time, "HH:mm:ii").format('HH:mm')

      http.post('schedules', {
        date: this.shedule.date,
        time: timeFormated,
        employee_id: this.shedule.employee_id,
        schedule_type_id: this.shedule.schedule_type_id,
        complement: this.complement,
        espirometria: this.espirometria,
        eletrocardiograma: this.eletrocardiograma,
        psicosocial: this.psicosocial,
        audiometria: this.audiometria,
        raiox: this.raiox,
        sangue: this.sangue
      })
      .then(response => {
        this.shedule = []
        this.audiometria = false,
        this.eletrocardiograma = false,
        this.psicosocial = false,
        this.espirometria = false,
        this.sangue = false,
        this.raiox = false,
        this.buscaAgendamentos()
        this.modalday.dialog = false
        swal({
          title: "Agendamento!",
          text: "cadastrado com sucesso!",
          icon: "success",
          timer: 1000,
          button: false

        });
      })
      .catch(error => {
        if(error.response.status == 422) {
          swal({
            title: "Atenção!",
            text: "Não será possível agendar nesta data, verifique!",
            icon: "warning",
            timer: 3000,
            button: true
          });

        }
      });
    },

    clickDelete(params) {

     let id_agendamento = params.row.id;
     swal({
      title: "Deseja excluir o agendamento?",
      text: "Caso precise agende novamente.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
     .then((willDelete) => {
      if(willDelete){

        http.delete('schedules/' + id_agendamento)
        .then(response => {
          this.buscaAgendamentos()
        });  
        swal("Agendamento excluído com sucesso!", {
          icon: "success",
          timer: 1500,
          button: false
        });
      } else{
        // swal("Não foi possível excluir o agendamento!")
      }
    });
   },

   updateShedules() {

    let timeFormated = moment(this.dados_shedules.time, "HH:mm:ii").format('HH:mm')

    http.put('schedules/' + this.dados_shedules.id, {
      date: this.dados_shedules.date,
      time: timeFormated,
      employee_id: this.dados_shedules.employee_id,
      schedule_type_id: this.dados_shedules.schedule_type_id,
      complement: this.dados_shedules.complement,
      espirometria: this.dados_shedules.espirometria,
      eletrocardiograma: this.dados_shedules.eletrocardiograma,
      psicosocial: this.dados_shedules.psicosocial,
      audiometria: this.dados_shedules.audiometria,
      raiox: this.dados_shedules.raiox,
      sangue: this.dados_shedules.sangue
    })
    .then(response => {
      this.buscaAgendamentos()
      this.audiometria = false,
      this.eletrocardiograma = false,
      this.psicosocial = false,
      this.espirometria = false,
      this.sangue = false,
      this.raiox = false,
      this.dados_shedules = []
      this.modalagendaedit.dialog = false
      swal({
        title: "Agendamento!",
        text: "atulizado com sucesso!",
        icon: "success",
        timer: 1000,
        button: false

      });
    })
    .catch(error => {
      if(error.response.status == 422) {
        swal({
          title: "Atenção!",
          text: "Não será possível agendar nesta data, verifique!",
          icon: "warning",
          timer: 3000,
          button: true
        });
      }
    });
  },

  buscarAllFuncionarios()
  {
    http.get('employees-all')
    .then(response => {
      this.employeesall = response.data;
    })
    .catch(error => {
    });
  },


  buscarFuncionarios()
  {
   this.loading = true; 
   let nome = this.funcionario.name;

   http.get('employees-all?q='+nome)
   .then(response => {

    this.employeesall = response.data;
    swal({
      title: "Funcionários!",
      text: "localizados com sucesso!",
      icon: "success",
      timer: 1000,
      button: false

    });
    if(response.data.length == 0)
    {
      swal({
        title: "Verifique,",
        text: "não localizamos nenhuma informação!",
        icon: "warning",
        timer: 2000,
        button: false

      });
    }  
    this.loading = false;
  })
   .catch(error => {
   });
 },

 creatEmpresaUser() {

    //grava user
    http.post('users', {
      email: this.empresa.email,
      password_visible: this.empresa.password_visible,
      password: this.empresa.password_visible,
      password_confirmation: this.empresa.password_visible,
      name: this.empresa.name,
      role: 0,
    })
    .then(response => {
      this.id_user = response.data.id
      swal({
        title: "Empresa!",
        text: "cadastrada com sucesso!",
        icon: "success",
        timer: 1000,
        button: false

      });
      this.criandEmpresa()
    })
    .catch(error => {
    });
  },

  creatEmpresa(){

    //grava empresa
    http.post('companies', {
      name: this.empresa.name,
      cnpj: this.empresa.cnpj,
      email: this.empresa.email,
      // user_id: this.id_user,
      phone: this.empresa.phone,
    })
    .then(response => {
      swal({
        title: "Empresa!",
        text: "cadastrada com sucesso!",
        icon: "success",
        timer: 1000,
        button: false

      });
      this.modalEmpresa.dialog = false;
      this.buscarAllFuncionarios()
      this.resetCreatComp();
    })
    .catch(error => {
    });
  },

  createFuncionario()
  {
    if (!this.funcionario.gender) {
        swal({
        title: "Selecione",
        text: "o sexo do colaborador!",
        icon: "warning",
        timer: 1800,
        button: false

      });
    }

    http.post('employees', {
      company_id: this.idEmpresa,
      name: this.funcionario.name,
      cpf: this.funcionario.cpf,
      office: this.funcionario.office,
      gender: this.funcionario.gender,
      born_date: this.dateNasicmento,
      admission: this.dateAdmission,
      rg: this.funcionario.rg,
      ctps: this.funcionario.ctps,
      pis: this.funcionario.pis
    })
    .then(response => {

      this.modalEmployeds.dialog = false;
      this.resetCreatFunc()
      this.buscarAllFuncionarios()
      swal({
        title: "Funcionário!",
        text: "cadastrado com sucesso!",
        icon: "success",
        timer: 1000,
        button: false

      });
    })
    .catch(error => {
      console.log()
    });
  },

  resetCreatComp()
  {
    this.empresa.name = '';
    this.empresa.cnpj = '';
    this.empresa.email = '';
    this.empresa.phone = '';
    this.empresa.ativo = '';
    this.empresa.password_visible = '';
    this.empresa.user_id = '';
  },

  resetCreatFunc()
  {

    this.funcionario.name = '';
    this.funcionario.cpf = '';
    this.funcionario.gender = '';
    this.funcionario.company_id = '';
    this.funcionario.office = '';
    this.dateNasicmento = '';
    this.dateAdmission = '';
    this.funcionario.rg = '';
    this.funcionario.ctps = '';
    this.funcionario.pis = '';
  },  



}
};
</script>
<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/agendamentos/Agendar.vue